<template>
  <div class="container">
     <div class="mate-head">
            <div class="mate-head">
                <div class="mate-head-left">品牌：</div>
                <div class="mate-head-r" :class="(allShow?'showAll':'')">
                  <span :class="{ cur: id1 == 0 }" @click="allBrand" class="mate-head-r-item">全部</span>
                    <p v-for="(item,index) in brand" :key="index" @click="changeBrand(item.supplierId, item.brand)" class="mate-head-r-item" :class="id1 == item.supplierId?'cur':''">{{item.brand}}</p>
                </div>
                <div class="mate-head-bottom" @click="showAllType">
                    <p v-if="!allShow"><i class="el-icon-arrow-down"></i>展开</p>
                    <p v-else><i class="el-icon-arrow-up"></i>隐藏</p>
                </div>
            </div>
            <div class="mate-head">
                <div class="mate-head-left">生产厂家：</div>
                <div class="mate-head-r" :class="(allShow?'showAll':'')">
                  <div :class="{ cur: id2 == 0 }" @click="allManufacturer" class="mate-head-r-item">全部</div>
                    <p v-for="(item,index) in manufacturer" :key="index" @click="changeManufacturer(item.supplierId, item.manufacturer)" class="mate-head-r-item" :class="id2 == item.supplierId?'cur':''">{{item.manufacturer}}</p>
                </div>
                 
            </div>
            <div class="mate-head">
                <div class="mate-head-left">材料名称：</div>
                <div class="mate-head-r" style="padding-top: 5px;">
                    <el-input v-model="search.productName" placeholder="请输入内容" clearable></el-input>
                    <el-button type="primary" plain style="margin-left:1vw;" @click="select">查询</el-button>
                </div>
            </div>
        </div>
    <!-- <div class="search">
      <div class="search-left">
        <div style="display: flex; margin-bottom: 2vh">
          <div style="width: 5vw; text-align: right">品牌：</div>
          <div class="search-item">
            <span :class="{ active: id1 == 0 }" @click="id1 = 0">全部</span>
            <span
              :class="{ active: id1 == item.supplierId }"
              v-for="item in brand"
              :key="item.supplierId"
              @click="changeBrand(item.supplierId, item.brand)"
              >{{ item.brand }}</span
            >
          </div>
        </div>
        <div style="display: flex; margin-bottom: 2vh">
          <div style="width: 5vw; text-align: right">生产厂家：</div>
          <div class="search-item">
            <span :class="{ active: id2 == 0 }" @click="id2 = 0">全部</span>
            <span
              :class="{ active: id2 == item.supplierId }"
              v-for="item in manufacturer"
              :key="item.supplierId"
              @click="changeManufacturer(item.supplierId, item.manufacturer)"
              >{{ item.manufacturer }}</span
            >
          </div>
        </div>
        <div style="display: flex; align-items: center">
          <div style="width: 5vw; text-align: right">材料名称：</div>
          <el-input
            placeholder="请输入"
            size="small"
            style="margin-right: 1vw"
            v-model="search.productName"
          ></el-input>
          <el-button size="small" @click="select">查询</el-button>
        </div>
      </div>
    </div> -->
    <div class="add">
      <el-button type="primary" size="small" @click="add2"
        >添加品牌和生产厂家</el-button
      >
      <el-button type="primary" size="small" @click="add">添加</el-button>
    </div>

    <el-table :data="tableData" border style="width: 100%" height="36vh">
      <el-table-column label="序号" type="index" :index="indexMethods" width="100"></el-table-column>
      <el-table-column prop="date" label="材料名称">
        <template slot-scope="scope">
          <span>{{ scope.row.productName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="品牌">
        <template slot-scope="scope">
          <span>{{ scope.row.brand }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="生产厂家">
        <template slot-scope="scope">
          <span>{{ scope.row.manufacturer }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
     <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="1"
      :page-sizes="[5, 10, 20, 50]"
      :page-size="5"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
    <el-dialog
      title="添加"
      :visible.sync="dialogVisible"
      width="30%"
     
    >
      <el-form ref="form" :model="form" label-width="120px" :rules="rules">
        <el-form-item label="品牌：" prop="brand" style="text-align: left;">
          <el-select v-model="form.brand" placeholder="请选择"  @change="change">
            <el-option
              v-for="item in brand"
              :key="item.brand"
              :label="item.brand"
              :value="item.brand"     
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="生产厂家：">
          <el-input v-model="form.manufacturer"></el-input>
        </el-form-item>
        <el-form-item label="材料名称：" prop="">
          <el-input v-model="form.productName"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="添加品牌和生产厂家"
      :visible.sync="addDialog"
      width="30%"
     
    >
      <el-form
        ref="addForm"
        :model="addForm"
        label-width="120px"
        :rules="rules"
      >
        <el-form-item label="品牌：" prop="brand">
          <el-input v-model="addForm.brand"></el-input>
        </el-form-item>
        <el-form-item label="生产厂家：" prop="manufacturer">
          <el-input v-model="addForm.manufacturer"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitAddForm('addForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import base from '../../../untils/base'
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
export default {
  data() {
    return {
      pageNum: 1,
      pageSize: 5,
      total: 0,
      allShow: false,
      id1: 0,
      id2: 0,
      search: {
        entId: util.session.get('groupId'),
        brand: '',
        manufacturer: '',
        productName: '',
      },
      tableData: [],
      brand: [],
      manufacturer: [],
      dialogVisible: false,
      addDialog: false,
      form: {
        supplierId: '',
        entId: util.session.get('groupId'),
        brand: '',
        manufacturer: '',
        productName: '',
      },
      addForm: {
        entId: util.session.get('groupId'),
        brand: '',
        manufacturer: '',
      },
      rules: {
        brand: [
          {
            required: true,
            message: '请输入',
            trigger: 'blur',
          },
        ],
        //  manufacturer: [
        //   {
        //     required: true, message: '请输入', trigger: 'blur'
        //   }
        // ]
      },
    }
  },
  mounted() {
    this.getData()
    this.getBrand()
    this.getManufacturer()
  },
  methods: {
    //查询
    select() {
      this.getData()
    },
    //  获取品牌
    getBrand() {
      myHttp
        .selectSupplierBrandList({
          entId: util.session.get('groupId'),
        })
        .then((resp) => {
          console.log(resp)
          if (resp.data.code == '200') {
            this.brand = resp.data.data
          }
        })
    },
    //获取生产厂家
    getManufacturer() {
      myHttp
        .selectSupplierManufacturerList({
          entId: util.session.get('groupId'),
        })
        .then((resp) => {
          console.log(resp)
          if (resp.data.code == '200') {
            this.manufacturer = resp.data.data
          }
        })
    },
    //展开
        showAllType(){
            this.allShow = !!!this.allShow
        },
    //  选择品牌
    changeBrand(id, brand) {
      this.id1 = id
      this.search.brand = brand
      this.getData()
    },
    //  选择生产厂家
    changeManufacturer(id, manufacturer) {
      this.id2 = id
      this.search.manufacturer = manufacturer
      this.getData()
    },
    getData() {
      console.log();
      if(this.id1 == 0){
        this.search.brand = ''
      }
      if(this.id2 == 0){
        this.search.manufacturer = ''
      }
      this.search.pageNum = this.pageNum
      this.search.pageSize = this.pageSize
      myHttp.selectAllProduct(this.search).then((resp) => {
        console.log(resp)
        if (resp.data.code == '200') {
          this.tableData = resp.data.data.list
          this.total = resp.data.data.total
        }
      })
    },
    allBrand(){
      this.id1 = 0
      this.getData()
    },
    allManufacturer() {
      this.id2 = 0
      this.getData()
    },
    change(val) {
      console.log(val);
      let brand = val
      console.log(this.brand);
      this.brand.forEach(item => {
        if(item.brand == brand){
          this.form.supplierId = item.supplierId
          this.form.manufacturer = item.manufacturer
          console.log(11);
        }
        
      })

    },
     handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.pageSize = val
        this.getData()
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.pageNum = val
        this.getData()
      },
      indexMethods(index){
        return (this.pageNum - 1) * this.pageSize + 1 + index
      },
    add() {
      this.dialogVisible = true
      this.form.supplierId = ''
      this.form.brand = ''
      this.form.manufacturer = ''
      this.form.productName = ''
    },
    add2() {
      this.addDialog = true
      this.addForm.brand = ''
      this.addForm.manufacturer = ''
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          myHttp.addSupplierProduct(this.form).then((resp) => {
            console.log(resp)
            if(resp.data.code == '200'){
              this.$message.success('添加成功')
              this.dialogVisible = false
              this.getData()
            }else{
              this.$message.error(resp.data.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submitAddForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          myHttp.addSupplier(this.addForm).then((resp) => {
            console.log(resp)
            if (resp.data.code == '200') {
              this.$message.success('添加成功')
              this.addDialog = false
              this.getBrand()
              this.getManufacturer()
            } else {
              this.$message.error(resp.data.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    //删除
    handleDelete(row){
       this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          myHttp
            .deleteSupplierProduct({
              productId: row.productId,
            })
            .then((resp) => {
              console.log(resp)
              if (resp.data.code == '200') {
                this.$message.success('删除成功')
                this.getData()
              }else{
                 this.$message.error(resp.data.msg)
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    }
  },
}
</script>

<style scoped>
@import '../../../assets/css/common.css';
.container {
  padding: 1vh 1vw;
  height: 100%;
}
.search {
  width: 100%;
  padding: 2vh 1vw;
  background-color: #fff;
}
.search-left {
  height: 100%;
  width: 80%;
}
.search-item > span {
  padding: 0.7vh;
  color: blue;
  cursor: pointer;
  margin-right: 1vw;
}
.active {
  background-color: blue;
  color: #fff !important;
  border-radius: 5px;
}
.add {
  text-align: right;
  margin: 1vh 0;
  padding: 0.7vh;
  background-color: #fff;
}
 .mate-head{
        width: 100%;
        height: auto;
        position: relative;
        background: #fff;
        padding: 2vh 1vw 1vh;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        justify-items: flex-start;
        align-content: flex-start;
        align-items: flex-start;
        border-bottom: 5px solid #ecf0f5;
    }
    .mate-head .mate-head{
        border-bottom:0;
        padding: 0;
    }
    .mate-head-left{
        width: 7vw;
        position: relative;
        text-align: right;
        padding: 1vh 0;
    }
    .mate-head-r{
        width: calc( 100% - 10vw );
        position: relative;
        height: 5vh;
        overflow: hidden;
        text-align: left;
    }
    .mate-head-r.showAll{
        height: auto;
    }
    .mate-head-r-item{
        width: auto;
        position: relative;
        margin-right: 0.5vh;
        display: flex;
        align-items: center;
        float: left;
        margin-bottom: 1vh;
        cursor: pointer;
        color: #3E50B4;
        padding: 1vh 1vw;
        border-radius: 5px;
    }
    .mate-head-r-item:hover,.mate-head-r-item.cur{
        background: #0490F9;
        color: #fff;
    }
    .mate-head-bottom{
        width: 3vw;
        display: flex;
        justify-items: flex-end;
        align-items: flex-end;
        min-height: 5vh;
        padding-bottom: 1vh;
        cursor: pointer;
    }
</style>